import { GridColDef } from '@mui/x-data-grid';
import { Box, Typography } from '@mui/material';

import NetZeroActions from './NetZeroActions';
import { formatYear } from '@Utils/datetime';
import { formatNumberWithDigit } from '@Utils/number';
import NetZeroTargetCell from './NetZeroTargetCell';
import { GasEmissionUnit } from '@Router/EsgGreenhouse/Components/GasEmissionMessage';

enum NET_ZERO_TABLE_COLUMN {
  ID = 'id',
  SCOPE = 'scope',
  BASE_YEAR = 'baseYear',
  NEAR_TERM_TARGET = 'nearTermTarget',
  LONG_TERM_TARGET = 'longTermTarget',
  ACCEPTANCE = 'acceptance',
  ACTION = 'action',
}

export const NET_ZERO_VISIBILITY = {
  [NET_ZERO_TABLE_COLUMN.ID]: false,
};

export const NET_ZERO_COLUMN: GridColDef[] = [
  { field: NET_ZERO_TABLE_COLUMN.ID, headerName: 'No.' },
  {
    field: NET_ZERO_TABLE_COLUMN.SCOPE,
    headerName: 'ขอบเขตการปล่อยก๊าซเรือนกระจก',
    minWidth: 150,
    renderCell: (fields) => {
      const { value } = fields;
      return (
        <Box>
          <Typography>{value.nameScopeTh}</Typography>
          <Typography mt={2}>{value.nameScopeEn}</Typography>
        </Box>
      );
    },
  },
  {
    field: NET_ZERO_TABLE_COLUMN.BASE_YEAR,
    headerName: 'ปีฐาน',
    minWidth: 200,
    renderCell: (fields) => {
      const { value } = fields;
      const formatYearTh = formatYear(value.year, 'th-TH');
      const formatYearEn = formatYear(value.year, 'en-EN');
      const formatQuantity = formatNumberWithDigit(value.gasEmissionQuantity);

      return (
        <Box>
          <Typography>
            {formatYearTh}: ปล่อยก๊าซเรือนกระจก {formatQuantity}{' '}
            <GasEmissionUnit />
          </Typography>
          <Typography mt={2}>
            {formatYearEn}: Greenhouse gas emissions {formatQuantity}{' '}
            <GasEmissionUnit />
          </Typography>
        </Box>
      );
    },
  },
  {
    field: NET_ZERO_TABLE_COLUMN.NEAR_TERM_TARGET,
    headerName: 'ปีเป้าหมายระยะสั้น',
    minWidth: 200,
    renderCell: (fields) => NetZeroTargetCell(fields),
  },
  {
    field: NET_ZERO_TABLE_COLUMN.LONG_TERM_TARGET,
    headerName: 'ปีเป้าหมายระยะยาว',
    minWidth: 200,
    renderCell: (fields) => NetZeroTargetCell(fields),
  },
  {
    field: NET_ZERO_TABLE_COLUMN.ACCEPTANCE,
    headerName: 'การรับรอง',
    minWidth: 200,
    flex: 1,
    renderCell: (fields) => {
      const { value } = fields;
      const hasTgo = value.isTgo === true;
      const hasSbti = value.isSbti === true;

      return (
        <Box>
          <Typography component={'li'}>
            องค์การบริหารจัดการก๊าซเรือนกระจก (อบก.):{' '}
            {hasTgo ? value.nameTgoTh : 'ไม่มี'}
          </Typography>
          <Typography component={'li'}>
            Science-based Targets (SBTi): {hasSbti ? value.nameSbtiTh : 'ไม่มี'}
          </Typography>
          <Typography mt={2} component={'li'}>
            Thailand Greenhouse Gas Management Organization (TGO):{' '}
            {hasTgo ? value.nameTgoEn : 'None'}
          </Typography>
          <Typography component={'li'}>
            Science-based Targets (SBTi): {hasSbti ? value.nameSbtiEn : 'None'}
          </Typography>
        </Box>
      );
    },
  },
  {
    field: NET_ZERO_TABLE_COLUMN.ACTION,
    headerName: 'แก้ไข/ลบ',
    headerAlign: 'left',
    type: 'actions',
    minWidth: 60,
    renderCell: (params) => {
      const { id } = params;
      return <NetZeroActions rowId={id} />;
    },
  },
];

export default NET_ZERO_COLUMN;
